import { useEffect, useState } from 'react';
import { getLogger } from '@sas/nova-core/logging';
import { isNullish } from '@sas/nova-core/typeguards';
import { useNCTextLocalizer } from '../../../../locale/useNCTextLocalizer';
import { postfixTestId } from '../../../../util/testId';
import { Select } from '../../../Select';
import { withLabels } from '../../../withLabels';
import { GlobalSettingsKeys, STARTUP_SCREEN_ACTION_VALUES } from '../../GlobalSettingsKeys';
import { useSettingsDialogDataProvider } from '../../SettingsDialog';
import { useSettingsField } from '../../store/SettingsStore';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectWithLabel = withLabels(Select);
const logger = getLogger('Settings');
export const StartupForm = () => {
  const localize = useNCTextLocalizer('Settings');
  const formName = 'settings-global-startupForm';
  const [startupScreenAction, setStartupScreenAction, resetStartupScreenAction] = useSettingsField(GlobalSettingsKeys.STARTUP_SCREEN_ACTION);
  const [specificAppDirective, setSpecificAppDirective] = useSettingsField(GlobalSettingsKeys.STARTUP_SCREEN_SPECIFIC_APP_DIRECTIVE);
  const [availableApps, setAvailableApps] = useState([]);
  const settingsDialogDP = useSettingsDialogDataProvider();
  useEffect(() => {
    let isMounted = true;
    async function fetchAvailableApps() {
      try {
        if (settingsDialogDP.getAvailableApps) {
          const availableApps = await settingsDialogDP.getAvailableApps();
          if (isMounted) {
            setAvailableApps(availableApps);
          }
        }
      } catch (error) {
        logger.error(`the remote call in startup screen setting form to fetch available apps has failed. details: ${error}`);
      }
    }
    fetchAvailableApps();
    return () => {
      isMounted = false;
    };
  }, [settingsDialogDP]);
  let selectedIndex = undefined; // first item is always the last signed out of app meta entry.

  const appRecordValues = [{
    id: 'lastAppDir',
    text: localize('settings.forms.startup.initialSceen.field.lastAppDirectiveField.label')
  }, ...availableApps.map(({
    appId,
    label
  }) => ({
    id: appId,
    text: label
  }))];
  if (startupScreenAction === STARTUP_SCREEN_ACTION_VALUES.SPECIFIC_APP_DIRECTIVE) {
    const entryIndex = appRecordValues.findIndex(record => record.id === specificAppDirective);
    if (entryIndex >= 1) {
      // comparison with 1 since first record is the meta record.
      selectedIndex = entryIndex;
    }
  } else if (startupScreenAction === STARTUP_SCREEN_ACTION_VALUES.LAST_APP_DIRECTIVE) {
    selectedIndex = 0;
  }
  return /*#__PURE__*/_jsx(SelectWithLabel, {
    testId: postfixTestId(formName, 'startupScreen'),
    label: localize('settings.forms.startup.initialscreen.field.label'),
    fieldMinWidth: '100%',
    values: appRecordValues,
    unselectedValue: {
      placeholder: localize('settings.forms.startup.initialscreen.placeholder.label')
    } // todo: Need placeholder label validated by UX
    ,
    selectedIndex: selectedIndex,
    onSelected: index => {
      if (!isNullish(index)) {
        if (index === 0) {
          setStartupScreenAction(STARTUP_SCREEN_ACTION_VALUES.LAST_APP_DIRECTIVE);
        } else {
          setStartupScreenAction(STARTUP_SCREEN_ACTION_VALUES.SPECIFIC_APP_DIRECTIVE);
          setSpecificAppDirective(appRecordValues[index].id);
        }
      } else {
        resetStartupScreenAction();
      }
    }
  });
};
//# sourceMappingURL=StartupForm.js.map